import { useContext } from "react";
import { FoodManagementContext } from "../context/createFoodManagementContext";

export const useFoodManagement = () => {
  const context = useContext(FoodManagementContext);
  if (context === undefined) {
    throw new Error(
      "useFoodManagement must be used within a FoodManagementProvider"
    );
  }
  return context;
};
